import React from "react";
import axios from 'axios';
import { useEffect, useState } from "react";

function SelCliente () {

  const [datos, setDatos] = useState([]);

  useEffect(() => {
    console.log('se ejecuta useeffect ClienteLista');
    axios({
      method: "POST",
      url:"/api/listacliente",
    })
    .then((response) => {
      console.log('axios: ', response.data.datos);
      setDatos(response.data.datos);
    }).catch((error) => {
      if (error.response) {
        console.log(error.response)
        console.log(error.response.status)
        console.log(error.response.headers)
        }
    })
  }, []);

  return (
    <>
      {datos.map((dato, idx) => {return <option value={dato.id_cliente}>{dato.nombre}</option>})}
    </>
  )
}

export default SelCliente;